import { FaUserCircle } from "react-icons/fa";
import { resolveUserAvatarSrc } from "../libs/avatar";

/**
 * Avatar tròn dùng chung header menu và trang profile.
 * @param {"sm"|"lg"} size — sm: menu top (30px), lg: profile (112px)
 */
const UserAvatarFrame = ({
  user,
  config,
  entityPicture,
  previewUrl,
  size = "sm",
  className = "",
  imgAlt = "",
}) => {
  const src = resolveUserAvatarSrc({ user, config, entityPicture, previewUrl });
  const sizeClass = size === "lg" ? "user-avatar-frame--lg" : "";

  return (
    <span
      className={`user-avatar-frame border ${sizeClass}${src ? "" : " user-avatar-frame--empty"} ${className}`.trim()}
    >
      {src ? (
        <img src={src} alt={imgAlt} />
      ) : (
        <span className="user-avatar-frame__placeholder" aria-hidden>
          <FaUserCircle />
        </span>
      )}
    </span>
  );
};

export default UserAvatarFrame;
